import { render, staticRenderFns } from "./Trivia16.vue?vue&type=template&id=32a29c82&scoped=true&"
import script from "./Trivia16.vue?vue&type=script&lang=js&"
export * from "./Trivia16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a29c82",
  null
  
)

export default component.exports